module.exports = __webpack_public_path__ + "static/media/大鳄问股@2x.dbdafbc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/大鳄问股@2x.png
// module id = 1579
// module chunks = 0